import { AxiosResponse } from 'axios';
import { IShipper } from '../_types';
import { request } from './http-client';

const getShipperById = (
  id: string,
  shipperId?: string
): Promise<AxiosResponse<IShipper>> =>
  request.get(`/v1/shippers/${id}`, {
    headers: shipperId ? { Shipper: shipperId } : undefined,
  });

export const getShippersList = async (params: any) => {
  const res = await request.get<{ shippers: IShipper[] }>('/v2/mika/shippers', {
    params,
  });
  return res.data;
};

export default getShipperById;
